export enum SchedulerPermissionDeniedReason {
    NoWritePermission = 'SCHEDULER_NO_WRITE_PERMISSION', // no project write or no employee write permission
    ProjectNotEditable = 'SCHEDULER_PROJECT_NOT_EDITABLE', // not project lead or active member of the project
    EmployeeOutOfScope = 'SCHEDULER_EMPLOYEE_OUT_OF_SCOPE' // employee outside the employee write scope (readWrite: only oneself) or not visible
}
